// Поддомен, по которому определяется школа слушателя.
// На localhost/frontend подставляем svetofor для локальной разработки.
export const subdomain = window.location.hostname.split(".")[0];

export const validSubdomain =
  subdomain === "localhost" || subdomain === "frontend"
    ? "svetofor"
    : subdomain;
